import { Link } from "react-router-dom";
import "./mainScreen.css";
import { IoMdCreate, IoMdDocument, IoMdAddCircle } from "react-icons/io";

const MainScreen = () => {
  return (
    <div className="bg-black mainDiv">
      <div className="flex w-full justify-evenly items-center">
        <div className="flex">
          <Link to="/booking">
            <button className=" icon-button">
              <IoMdCreate className="icon" /> Data Entry
            </button>
          </Link>
          {/* <Link to="/reportsComponent">
            <button className=" icon-button">
              <IoMdDocument className="icon" /> View Reports
            </button>
          </Link>
          <Link to="/party">
            <button className=" icon-button">
              <IoMdAddCircle className="icon" /> Add Column
            </button>
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default MainScreen;
